import { NgClass } from '@angular/common';
import { Component, ElementRef, inject } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MssFieldBaseFieldTypeComponent } from '@shared/components/formly/fields/mss-field-base.component';
import { ModalService } from '@shared/services/modal.service';

@Component({
  templateUrl: 'buttons.component.html',
  styleUrls: ['buttons.component.scss'],
  imports: [NgClass, NgbTooltipModule],
})
export class ButtonsFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly modalService = inject(ModalService);

  public get numColumns(): number {
    return this.props.numColumns ?? 3;
  }

  public handleButtonClick(button: { onClick?: (field: any) => void; eventName?: string; [key: string]: any }) {
    if (typeof button.onClick === 'function') {
      button.onClick(this.field);
    }

    if (typeof button.eventName === 'string') {
      const event = new Event(button.eventName, { bubbles: true, composed: true });
      this.el.nativeElement.dispatchEvent(event);
    }
  }

  public handleButtonTooltip(button: { tooltip?: string | ((field: any) => string | undefined) }) {
    if (typeof button.tooltip === 'function') {
      return button.tooltip(this.field);
    }

    return button.tooltip;
  }

  public handleButtonDisabled(button: { disabled?: boolean | ((field: any) => boolean) }) {
    if (typeof button.disabled === 'function') {
      return button.disabled(this.field);
    }

    return button.disabled;
  }

  public openTooltip() {
    this.modalService
      .open({
        title: this.props.label,
        message: this.props.tooltip,
      })
      .then(
        () => null,
        () => null,
      );
  }
}
